/**
 * main.js
 *
 * @version 1.0.0
 * @copyright 2018 SEDA.digital GmbH & Co. KG
 */

// Dispatch a global event when the main js has been loaded
// this can be used by inlined scripts to know when jQuery is available
window.dispatchEvent(new CustomEvent('jsloaded'));

/**
 * Foundation Framework JS
 *
 * when using any of these, `foundation.core` always needs to be enabled
 * and you need to initialize Foundation (see code below imports)
 */

import { Foundation } from 'foundation-sites/js/foundation';


// ### import "_modernizr.js";
// import "../node_modules/jquery/dist/jquery.min.js";
// import "../node_modules/foundation-sites/dist/js/plugins/foundation.core.js";
// import "../node_modules/foundation-sites/dist/js/plugins/foundation.util.keyboard.js";
// import "../node_modules/foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js";
// import "../node_modules/foundation-sites/dist/js/plugins/foundation.util.triggers.js";
// import "../node_modules/foundation-sites/dist/js/plugins/foundation.util.motion.js";
// import "../node_modules/foundation-sites/dist/js/plugins/foundation.offcanvas.js";
import "../vendor/lodash/lodash.custom.js";
// import "../node_modules/jquery-countdown/dist/jquery.countdown.js";
import '../node_modules/modaal/dist/js/modaal';
import './components/filepond'

import CommonMethods from './components/CommonMethods';
import Embed from './components/Embed';

const commonMethods = new CommonMethods()
const embed = new Embed(commonMethods)

// Init Foundation
Foundation.addToJquery(jQuery);

import { Countdown } from './components/countdown.js';

import { InitFaq } from './components/faq.js';


$(document).ready(function () {
    window.initialScriptsLoaded = true;
    var e = document.createEvent('Event');
    e.initEvent('initialScriptsLoaded', false, true);
    window.dispatchEvent(e);

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *	init Foundation Components
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $(document).foundation();


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	mobile navigation toggle / hamburger
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    var $nav = $('.off-canvas'),
        $menuButton = $('.open-off-canvas'),
        $triggerWord = $('.open-off-canvas .trigger-status');

    // opened event
    $('#mainOffCanvas').on('opened.zf.offcanvas', function () {
        $menuButton.addClass('active');
        $triggerWord.text('schließen');
    });

    // closed event
    $('#mainOffCanvas').on('closed.zf.offcanvas', function () {
        $menuButton.removeClass('active');
        $triggerWord.text('öffnen');
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *	shrink header
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
    var shrinkHeader = 250;
    $(window).scroll(function () {
        var scroll = window.pageYOffset || document.documentElement.scrollTop;
        //var windowWidth = getCurrentWidth();
        if (scroll >= shrinkHeader) { // && windowWidth >= 768) {
            $('.pageheader').addClass('shrink');
        }
        else {
            $('.pageheader').removeClass('shrink');
        }
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	scroll to id from url hash
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
/*
    if (window.location.hash !== '' && window.location.hash.charAt(1) != '&' && $(window.location.hash).length > 0) {
        setTimeout(function () {
            $('.pageheader').addClass('shrink');
            $('html, body').animate({ scrollTop: $(window.location.hash).offset().top - 125 }, 1000);
        }, 500);
    }
*/

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	process link tags
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $('body').on('click', 'a', function (e) {
        var href = $(this).attr('href');

        // scroll to id if hash link clicked
        if (href && href.charAt(0) == '#' && href.length > 1 && $(href).length && $(this).hasClass('noscroll') === false) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: ($(href).offset().top - 125)
            }, 1000);
            return false;
        }

        return true;
    });

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	float inline labels (done via CSS, this is a enhancement)
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    $('body').on('keyup', 'input, textarea', function () {
        if ($(this).val().length) {
            $(this).addClass('filled');
        } else {
            $(this).removeClass('filled');
        }
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     *	Gallery Lightbox / Modal (http://www.humaan.com/modaal/)
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
    $('.gallery-image').modaal({
        type: 'image',
        close_text: 'Schließen',
        close_aria_label: 'Schließen (Escape Taste drücken zum schließen)',
        confirm_button_text: 'OK',
        confirm_cancel_button_text: 'Abbrechen',
        loading_content: 'Lade &hellip;'
    });
});
